<template>
    <v-hover>
        <template v-slot:default="{ hover }">
            <v-card class="pa-4 transition-swing rounded-lg" :elevation="hover ? 6 : 2" :color="'surface'">
                <!-- Header -->
                <v-row no-gutters align="center" class="mb-2">
                    <v-col cols="auto" class="mr-3 cursor-pointer" @click="$emit('click')">
                        <v-sheet rounded="lg" class="d-flex align-center justify-center" :color="color + ' lighten-5'"
                            height="48" width="48">
                            <v-icon :color="color">
                                {{ icon }}
                            </v-icon>
                        </v-sheet>
                    </v-col>
                    <v-col>
                        <div class="d-flex align-center cursor-pointer" @click="$emit('click')">
                             <div class="text-caption text--secondary font-weight-medium text-uppercase mr-1">
                                {{ title }}
                            </div>
                            <v-tooltip bottom v-if="tooltipText" max-width="300">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon x-small color="grey lighten-1" v-bind="attrs" v-on="on" @click.stop>
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>{{ tooltipText }}</span>
                            </v-tooltip>
                        </div>
                       
                        <div v-if="!loading" :class="'text-h5 font-weight-bold ' + color + '--text cursor-pointer'" @click="$emit('click')">
                            {{ titleValue }}
                        </div>
                        <v-skeleton-loader v-else type="text" width="60%" />
                    </v-col>
                </v-row>

                <!-- Custom Slot Content -->
                <v-expand-transition>
                    <div v-if="$scopedSlots.default">
                        <slot name="default" />
                    </div>
                </v-expand-transition>

                <!-- Chart Section -->
                <v-row no-gutters class="mt-4">
                    <v-col cols="12">
                        <apexchart v-if="!loadingCharts" type="area" height="100px" :options="computedChartOptions"
                            :series="chartSeries" />
                        <v-skeleton-loader v-else type="image" height="100px" />
                    </v-col>
                </v-row>

                <!-- Progress Section -->
                <v-divider class="my-3" />
                <v-row v-if="progressTotalLabel" no-gutters align="center" @click="$emit('clickProgress')"
                    class="cursor-pointer">
                    <v-col cols="12">
                        <div class="d-flex justify-space-between text-caption mb-1">
                            <span class="text--secondary">{{ descriptionPercent }}</span>
                            <span class="font-weight-bold">{{ progressTotalLabel }}</span>
                        </div>
                        <v-progress-linear :color="color" :indeterminate="loading" :value="progressValue" rounded
                            height="8" background-opacity="0.2"></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: ""
        },
        tooltipText: {
            type: String,
            default: ""
        },
        titleValue: {
            type: [String, Number],
            default: ""
        },
        chartOptions: {
            type: [Object, Array],
            default: () => ({})
        },
        chartSeries: {
            type: [Object, Array],
            required: true
        },
        descriptionPercent: {
            type: String,
            default: "do previsto"
        },
        progressValue: {
            type: [Number, String],
            default: 0
        },
        progressTotalLabel: {
            type: [String, Number],
            default: ""
        },
        loading: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "primary"
        },
        loadingCharts: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedChartOptions() {
            // Merge default options with prop options to ensure clean look
            const options = this.chartOptions || {};
            const chart = options.chart || {};

            return {
                ...options,
                chart: {
                    ...chart,
                    toolbar: { show: false },
                    sparkline: { enabled: true } // Simplify chart for card view
                },
                grid: { show: false },
                dataLabels: { enabled: false },
                xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
                yaxis: { show: false },
                stroke: { curve: 'smooth', width: 2 },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.45,
                        opacityTo: 0.05,
                        stops: [50, 100, 100]
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>